var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('rect',{attrs:{"x":"0.547852","y":"5.25","width":"14","height":"14","rx":"1.5","fill":"white","stroke":"#0E3746"}}),_c('rect',{attrs:{"x":"5.04785","y":"0.75","width":"14","height":"14","rx":"1.5","fill":"white","stroke":"#0E3746"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }